var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 10.9V15.1C14 18.6 12.6 20 9.1 20H4.9C1.4 20 0 18.6 0 15.1V10.9C0 7.4 1.4 6 4.9 6H9.1C12.6 6 14 7.4 14 10.9Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1004 0H10.9004C7.81743 0 6.37043 1.094 6.07043 3.739C6.00643 4.292 6.46543 4.75 7.02243 4.75H9.10043C13.3004 4.75 15.2504 6.7 15.2504 10.9V12.978C15.2504 13.535 15.7074 13.993 16.2604 13.93C18.9074 13.63 20.0004 12.183 20.0004 9.1V4.9C20.0004 1.4 18.6004 0 15.1004 0Z",
    fill: "#455A64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4f2d1e5c719a4027a117a81089380f48.svg";
export { ForwardRef as ReactComponent };